import type { Brand } from "@/api/client";
import { brandMarkColors } from "@/lib/brand-style";

/**
 * A brand's mark: its initial on its own accent (the console has no logo files for the brands
 * yet). The brand being edited wears the derived role tokens; another brand (in the switcher)
 * gets the same derivation from its manifest accent, so every mark reads.
 */
export function BrandMark({ brand, current, size = "md" }: { brand: Brand; current?: boolean; size?: "sm" | "md" | "lg" }) {
  const box = size === "sm" ? "size-8 rounded-xl text-sub-title-2" : size === "lg" ? "size-12 rounded-2xl text-h5" : "size-10 rounded-xl text-sub-title-1";
  const colors = current ? undefined : brandMarkColors(brand.accent);
  return (
    <span
      className={`flex shrink-0 items-center justify-center font-semibold ${box} ${current ? "bg-accent text-on-accent" : ""}`}
      style={colors ? { backgroundColor: colors.fill, color: colors.ink } : undefined}
      aria-hidden="true"
    >
      {brand.name.slice(0, 1)}
    </span>
  );
}
